module.exports = __webpack_public_path__ + "img/W7042-full.1926060f.jpg";